import { render } from "./SearchResultTemplate.vue?vue&type=template&id=30804f24&scoped=true"
import script from "./SearchResultTemplate.vue?vue&type=script&lang=js"
export * from "./SearchResultTemplate.vue?vue&type=script&lang=js"

import "./SearchResultTemplate.vue?vue&type=style&index=0&id=30804f24&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-30804f24"

export default script